import { main } from './addon';
export const theme = {
  bg: {
    default: '#FFFFFF',
    reverse: '#16171A',
    wash: '#FAFAFA',
    divider: '#F6F7F8',
    border: '#EBECED',
    inactive: '#DFE7EF',
    testing: '#000000',
  },
  brand: {
    default: '#4400CC',
    alt: '#7B16FF',
    wash: '#E8E5FF',
    border: '#DDD9FF',
    dark: '#2A0080',
    blue: '#464ac9',
  },
  generic: {
    default: '#E6ECF7',
    alt: '#F6FBFC',
  },
  social: {
    facebook: {
      default: '#3B5998',
      alt: '#5A85DF',
    },
    twitter: {
      default: '#00ACED',
      alt: '#53D0FF',
    },
    google: {
      default: '#ea4335',
      alt: '#ea4335',
    },
    github: {
      default: '#16171A',
      alt: '#828C99',
    },
    ph: {
      default: '#D85537',
      alt: '#D85537',
    },
  },
  space: {
    default: '#0062D6',
    alt: '#1CD2F2',
    wash: '#E5F0FF',
    border: '#BDD8FF',
    dark: '#0F015E',
  },
  special: {
    default: '#E58306',
    alt: '#F1C742',
    dark: '#7D4A00',
    wash: '#FFF5E5',
    border: '#FFE6BF',
  },
  success: {
    default: '#00B88B',
    alt: '#00D5BD',
    dark: '#00663C',
    wash: '#D9FFF2',
    border: '#9FF5D9',
  },
  text: {
    default: '#24292E',
    secondary: '#384047',
    alt: '#67717A',
    placeholder: '#7C8894',
    reverse: '#FFFFFF',
    blue: '#464ac9',
  },
  warn: {
    default: '#E22F2F',
    alt: '#E2197A',
    dark: '#85000C',
    wash: '#FFEDF6',
    border: '#FFCCE5',
  },
  ios: {
    red: '#FF3B30',
    orange: '#FF9500',
    yellow: '#FFCC00',
    green: '#4CD964',
    tealBlue: '#5AC8FA',
    blue: '#007AFF',
    purple: '#5856D6',
    pink: '#FF2D55',
  },
  community: {
    darkNavy: '#1d1e2b',
    stone: '#73747d',
    coolGrey: '#a9acc0',
    paleGrey: '#e3e7ed',
    mist: '#f3f6fa',
    indigo: '#464ac9',
    salmon: '#ed4b53',
    orange: '#ff764c',
    yellow: '#fdaa02',
    lightGray: '#f6f7fa',
    cyan: '#12c39a',
  },
  avatar: {
    avatar0: '#ca0915',
    avatar1: '#ff5f00',
    avatar2: '#cda132',
    avatar3: '#b5ba1b',
    avatar4: '#64a324',
    avatar5: '#157112',
    avatar6: '#17b0a0',
    avatar7: '#1271ac',
    avatar8: '#1e4c77',
    avatar9: '#1b2387',
    avatar10: '#9b19ff',
    avatar11: '#620ba6',
    avatar12: '#d30f8e',
    avatar13: '#860759',
  },
  main,
};

export default theme;
